module.exports = __webpack_public_path__ + "assets/gridbg-2-e92040ea5adf8dc26855baa6017c6e0d.png";


//////////////////
// WEBPACK FOOTER
// ./button/libs/mfButtons/images/gridbg-2.png
// module id = 57
// module chunks = 4